/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { SurfaceCompetitionResponse } from './SurfaceCompetitionResponse';
import {
    SurfaceCompetitionResponseFromJSON,
    SurfaceCompetitionResponseFromJSONTyped,
    SurfaceCompetitionResponseToJSON,
    SurfaceCompetitionResponseToJSONTyped,
} from './SurfaceCompetitionResponse';

/**
 * 
 * @export
 * @interface GetCompetitionItemsResponse
 */
export interface GetCompetitionItemsResponse {
    /**
     * 
     * @type {Array<SurfaceCompetitionResponse>}
     * @memberof GetCompetitionItemsResponse
     */
    competitions: Array<SurfaceCompetitionResponse>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetCompetitionItemsResponse
     */
    paginationInfo: PaginationInfo;
}

/**
 * Check if a given object implements the GetCompetitionItemsResponse interface.
 */
export function instanceOfGetCompetitionItemsResponse(value: object): value is GetCompetitionItemsResponse {
    if (!('competitions' in value) || value['competitions'] === undefined) return false;
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    return true;
}

export function GetCompetitionItemsResponseFromJSON(json: any): GetCompetitionItemsResponse {
    return GetCompetitionItemsResponseFromJSONTyped(json, false);
}

export function GetCompetitionItemsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCompetitionItemsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'competitions': ((json['competitions'] as Array<any>).map(SurfaceCompetitionResponseFromJSON)),
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
    };
}

export function GetCompetitionItemsResponseToJSON(json: any): GetCompetitionItemsResponse {
    return GetCompetitionItemsResponseToJSONTyped(json, false);
}

export function GetCompetitionItemsResponseToJSONTyped(value?: GetCompetitionItemsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'competitions': ((value['competitions'] as Array<any>).map(SurfaceCompetitionResponseToJSON)),
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
    };
}

